// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";
import { alertsClasses as myClasses } from "src/controllers/alerts";

import { HTMLDivProps, Text } from "@blueprintjs/core";

import { DuoButtons, ToolBar } from 'src/components';

import "./styles.css";

export interface IGroupsHeaderProps extends HTMLDivProps {
  groupsSelected?: number;
  onCancelClick?(event: any): void;
  onSaveClick?(event: any): void;
}

export const GroupsHeader: React.SFC<IGroupsHeaderProps> = props => {
  const { className, groupsSelected, onCancelClick, onSaveClick } = props;

  const classes = classNames(
    myClasses.ALERTS_CONTENT_COMPOSE_CHOOSE_AUDIENCE_HEADER,
    className
  );

  const leftElement = <Text> Select Groups </Text>;

  const rightElement = (
    <React.Fragment>
      <Text>
        {groupsSelected && groupsSelected > 0 ? (
          groupsSelected + " Groups Selected"
        ) : null}
      </Text>
      <DuoButtons
        firstButtonText="cancel"
        secondButtonText="save"
        firstButtonClick={onCancelClick}
        secondButtonClick={onSaveClick}
      />
    </React.Fragment>
  );

  return (
    <ToolBar
      className={classes}
      leftElement={leftElement}
      rightElement={rightElement}
    />
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/choose-audience/groups-header.tsx